import { Flex } from '@modusign/design-system';
import { useSigners } from '@modusign/react-signing';

import TemplateSignerDetailSetUpItem from '@app/features/template/components/TemplateSignerDetailSetUpCard/TemplateSignerDetailSetUpItem';

export default function TemplateSignerDetailSetUpCard() {
  const { signers } = useSigners();

  return (
    <Flex backgroundColor="#D2D2D2" borderRadius="3px" flexDirection="column" gap={4} mb={4} p={4}>
      {signers.map((signer) => {
        return <TemplateSignerDetailSetUpItem key={signer.id} signer={signer} />;
      })}
    </Flex>
  );
}
